import request from '@/util/request'


export const trainLeixingList = (data) => request.post('/api/trainLeixingList', data);  //培训类型列表

export const trainLeixingAdd = (data) => request.post('/api/trainLeixingAdd', data);  //培训类型添加

export const trainLeixingEdit = (data) => request.post('/api/trainLeixingEdit', data);  //培训类型编辑

export const trainLeixingDel = (data) => request.post('/api/trainLeixingDel', data);  //培训类型删除

export const trainLeixingDetail = (data) => request.post('/api/trainLeixingDetail', data);  //培训类型详情